import { gql } from "@apollo/client";

export const MEDICINE = gql`
    query queryMedicine($id: Float!) {
        medicine(id: $id) {
            id
            name
            need
            stock
            box
            due_date
            is_actived
            is_deleted
        }
    }
`;

export const MEDICINES = gql`
    query queryMedicines {
        medicines {
            id
            name
            need
            stock
            box
            due_date
            is_actived
            is_deleted
        }
    }
`;

export const MEDICINES_REPORT = gql`
    query queryMedicinesReport($filter: MedicineFilterInput, $sort: MedicineSortInput) {
        medicines(filter: $filter, sort: $sort) {
            id
            name
            need
            stock
            box
            due_date
            is_actived
            is_deleted
            created_at
        }
    }
`;

export default MEDICINE;
